const SELECTINPUT_COLOR = {
  black: 'black',
  purple_dark: 'purple-dark',
}

export { SELECTINPUT_COLOR }
